import React, {useEffect,useState } from 'react'
import Layout from '../../../component/layout/Layout'
import 'aos/dist/aos.css';
import AOS from 'aos';

import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import firebaseConfig from '../../firebase/firebaseConfig';

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();


const Textile = () => {
    const [activeSlide, setActiveSlide] = useState(0);
    const [productData, setProductData] = useState([]);

    const handleSlideChange = (index) => {
        setActiveSlide(index);
    };

    useEffect(() => {
        AOS.init({
            duration: 1000,
        });

        const fetchData = async () => {
            try {
                const querySnapshot = await db.collection('Textiletesting').get();
                const data = querySnapshot.docs.map(doc => doc.data());
                setProductData(data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

  return (
    <Layout>
      <section id="hero">
                <div id="heroCarousel" className="carousel slide carousel-fade" data-bs-interval="5000" data-bs-ride="carousel">
                    <ol className="carousel-indicators" id="hero-carousel-indicators">
                        <li
                            data-bs-target="#heroCarousel"
                            data-bs-slide-to="0"
                            className={activeSlide === 0 ? "active" : ""}
                            onClick={() => handleSlideChange(0)}
                        ></li>
                    </ol>
                    <div className="carousel-inner" role="listbox">
                        <div className={`carousel-item ${activeSlide === 0 ? "active" : ""}`} style={{ backgroundImage: "url(/img/Carousel/instruments-header-1024x423.jpg)" }}>
                            <div className="carousel-container">
                                <div className="container">
                                    <div className="text" id='text'>
                                        <h2 className="animate__animated animate__fadeInDown">Textile Testing</h2>
                                        <p className="animate__animated animate__fadeInUp">Instruments and equipments offered by Rishabh provide
                                            solutions for Automation, Process Control, Research and Development and quality measurement to the
                                            Pulp and Paper industry as well as to Water, Waste Water and other industrial applications. Products
                                            include laboratory and Online Charge Analysers, Zeta Potential Analyzers, Laboratory Flocculators,
                                            Portable & Process viscometers, Dispersion Analyser, On-line Concentration / Density Monitor, and
                                            other water quality parameter monitoring systems.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <br />
            {productData.map((section, index) => (
                <div className="container cta-100" key={index}>
                    <div className="container">
                        <div className="row blog">
                            <div className="col-md-12">
                                <div
                                    id={`blogCarousel-${index}`}
                                    className="carousel slide container-blog"
                                    data-ride="carousel"
                                >
                                    <div className="section-title text-center">
                                        <h1>{section.sectionTitle}</h1>
                                    </div>
                                    <br />
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <div className="row">
                                                {section.products.map((product, idx) => (
                                                    <div
                                                        className="col-md-4"
                                                        key={idx}
                                                        style={{
                                                            display: "flex",
                                                            marginBottom: "20px"
                                                        }}
                                                    >
                                                        <div
                                                            className="item-box-blog"
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                height: "100%",
                                                                width: "100%",
                                                                border: "1px solid #dcdcdc",
                                                                borderRadius: "12px",
                                                                overflow: "hidden",
                                                                backgroundColor: "#fff",
                                                                boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                                                                transition: "all 0.3s ease"
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.boxShadow =
                                                                    "0 8px 20px rgba(0,0,0,0.15)";
                                                                e.currentTarget.style.transform =
                                                                    "translateY(-5px)";
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.boxShadow =
                                                                    "0 2px 10px rgba(0,0,0,0.08)";
                                                                e.currentTarget.style.transform =
                                                                    "translateY(0)";
                                                            }}
                                                        >
                                                            {/* Image */}
                                                            <div className="item-box-blog-image">
                                                                <figure style={{ margin: 0 }}>
                                                                    <img
                                                                        alt={product.title}
                                                                        src={product.imageUrl}
                                                                        style={{
                                                                            width: "100%",
                                                                            height: "200px",
                                                                            objectFit: "cover"
                                                                        }}
                                                                    />
                                                                </figure>
                                                            </div>

                                                            {/* Content */}
                                                            <div
                                                                className="item-box-blog-body"
                                                                style={{
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    flexGrow: 1,
                                                                    justifyContent: "space-between",
                                                                    padding: "15px"
                                                                }}
                                                            >
                                                                <div className="item-box-blog-heading">
                                                                    <a href="#" tabIndex="0">
                                                                        <h5
                                                                            style={{
                                                                                minHeight: "50px",
                                                                                marginBottom: "10px",
                                                                                fontWeight: "600"
                                                                            }}
                                                                        >
                                                                            {product.title}
                                                                        </h5>
                                                                    </a>
                                                                </div>

                                                                <a
                                                                    href={product.url}
                                                                    className="get-started-btn"
                                                                    style={{
                                                                        marginTop: "auto",
                                                                        textAlign: "center",
                                                                        padding: "10px",
                                                                        backgroundColor: "#007bff",
                                                                        color: "#fff",
                                                                        borderRadius: "6px",
                                                                        textDecoration: "none",
                                                                        fontWeight: "500"
                                                                    }}
                                                                >
                                                                    View Products
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Carousel */}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
            <br />
    </Layout>
  )
}

export default Textile
